export const addhttps = url => {
  const pattern = /^((http|https):\/\/)/

  if (!pattern.test(url)) {
    return `https://${url}`
  }

  return url
}


// WEBPACK FOOTER //
// ./src/scripts/app/modules/integrations/helpers.js